export default "__VITE_ASSET__yJRBQgWF__"